import './style.scss'; 
 
import React, { FC } from 'react';
import { motion } from "framer-motion";

import { Link } from "react-router-dom";
 
const TermsAgreement: FC = () => {
    return (
        <motion.div
            className="text-center text-gray-600 text-sm mt-10"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
        >
            <p className="text-dark">
                En rejoignant, vous acceptez nos{" "}
                <Link to="https://idprotect.fr/cgv-cgu/" className="text-primary my-link">
                    Conditions d'utilisation
                </Link>{" "}
                et notre{" "}
                <Link to="https://idprotect.fr/politique-de-confidentialites/" className="text-primary my-link">
                    Politique de confidentialité
                </Link>.
            </p>
        </motion.div>
    );
} 
 
export default TermsAgreement; 
